<template>
    <div class="Home container">
        <Btn></Btn>
        <Card>
            <div class="cardWrapper mt-2">
                <div @click="$router.go(-1)"  class="kembali backBtn text-blue mb-2"><i class="fas fa-chevron-left"></i> Kembali</div>
                <div class="text-right">Nomor Anggota</div>
                <div class="text-right mb-1 text-bold">2343534656768009</div>
                <form action="">
                    <label for="nohp">Nomor Handphone</label>
                    <input name="nohp" class="input-outline" type="number">
                    <label for="password">Kata Sandi</label>
                    <input name="password" class="input-outline" type="password">
                    <label for="repassword">Ulangi Kata Sandi</label>
                    <input type="password" class="input-outline" name="repassword">
                    <button class="btn-fill blue rounded mt-2">Registrasi Ulang</button>
                </form>
                <button @click="$router.go(-1)" class="btnBackBottom btn-outline blue rounded">Kembali</button>
            </div>
        </Card>
    </div>
</template>

<script>
import Card from '../components/cardCenter.vue'
import Btn from '../components/backBtn.vue'
export default {
  components: {
    Card,
    Btn
  }
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/Layout/home.scss';
</style>
